<template>
    <div class="main_diy">
        <div class="form">
            <el-row >
                <div class="title">图片裁剪工具</div>
            </el-row>
            <el-row style="margin:10px 0">
                <el-col style="width:200px">
                    <label class="lab">请选择图片</label>
                </el-col>
                <el-col style="width:calc(100% - 300px)">
                    <input type="text" class="file_path" v-model="filetext">
                </el-col>
                <el-col style="width:100px;position:relative">
                    <el-button type="primary" style="width:100%;background: #409EFF;border: 1px solid rgb(64, 158, 255);border-radius: 0;">{{label}}</el-button>
                    <input type="file" class="file_dy" @change="selectFile" id="fileupload">
                </el-col>
            </el-row>
            <el-row  style="margin:10px 0">
                <el-col style="width:200px;">
                    <label class="lab">裁剪长度(像素)</label>
                </el-col>
                <el-col style="width:calc(100% - 200px)">
                    <input type="text" v-model="pxwidth" class="file_path" placeholder="选择图片后会自动填充原来图片的长度,裁剪长度不能大于此数字" onkeyup="this.value=this.value.replace(/\D/g,'')">
                </el-col>
            </el-row>
            <el-row>
                <el-col style="width:200px;">
                    <label class="lab">裁剪宽度(像素)</label>
                </el-col>
                <el-col style="width:calc(100% - 200px)">
                    <input type="text" v-model="pxheight"  class="file_path"  placeholder="选择图片后会自动填充原来图片的宽度,裁剪宽度不能大于此数字"  onkeyup="this.value=this.value.replace(/\D/g,'')">
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" style="text-align: center;">
                    <el-button type='primary' style="background: #409EFF;margin-top:20px" @click="submit">确认</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="form">
            <el-row >
                <div class="title">图片下载工具</div>
            </el-row>
            <el-row style="margin:10px 0">
                <el-col style="width:200px">
                    <label class="lab">请输入网址</label>
                </el-col>
                <el-col style="width:calc(100% - 300px)">
                    <input type="text" class="file_path" v-model="inputpath" placeholder="请输入图片下载地址">
                </el-col>
                <el-col style="width:100px;position:relative">
                    <el-button type="primary" style="width:100%;background: #409EFF;border: 1px solid rgb(64, 158, 255);border-radius: 0;" @click='Adressumbit'>确定</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="form">
            <el-row >
                <div class="title">去除水印工具</div>
                <input type="file" id="upload">
                <button @click="upload">up</button>
            </el-row>
            <el-row style="margin:10px 0">
              <waterMark></waterMark>
            </el-row>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    .main_diy{
        width: 100%;
        height: 100%;
        padding: 20px;
       
    }
    .form{
        width: 800px;
        margin: auto;
        border: 1px solid #eee;
        padding: 20px;
        margin-bottom: 40px;
    }
    .lab{
        width: 100%;
        text-align: center;
        background: #409EFF;
        height: 30px;
        line-height: 30px;
        border: 1px solid #409EFF;
        border-right: 0;
        color: #fff;
    }
    .file_path{
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        border: 1px solid #409EFF;
    }
    .file_dy{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        opacity: 0;
        width: 100%;
    }
</style>
<script>
import waterMark from '@/views/waterMark.vue'    
import axios from 'axios';
import fsvc from "@/api/FileService.js";
export default {
    name:'InternalUseTools',
    components: { waterMark },
    data(){
        return{
            filetext:'',
            label:'请选择',
            width:'',//选择图片长度
            height:'',//选择图片宽度
            pxwidth:'',
            pxheight:'',
            filepath:'',
            inputpath:'',//输入的网址
        }
    },
    mounted(){
      
    },
    methods:{
        selectFile(val){
            var self=this;
            var filepath=document.getElementById("fileupload").files[0];
            let reader = new FileReader();
            if(filepath){
                 let type=filepath.type;
                 if(type.indexOf('image')>-1){
                    this.filetext=filepath.name;
                    this.label='已选择'
                    this.filepath=this.getPath(filepath);
                 }else{
                    this.$message.error("只支持上传图片");
                    this.filetext="";
                    this.label='请选择'
                    this.filepath=""
                 }
                reader.readAsDataURL(filepath);//这里把一个文件用base64编码,具体什么是base64编码,我将稍后在不久的文章中介绍
                reader.onload = function(e){
                        let img = new Image();
                        img.src = e.target.result;//获取编码后的值,也可以用this.result获取
                        img.onload = function () {
                        console.log('height:'+this.height+'----width:'+this.width)
                        self.pxwidth=this.width;
                        self.pxheight=this.height;
                        self.width=this.width;
                        self.height=this.height;
                    }
                }
            }else{
                this.filetext="";
                this.filepath='';
                self.pxwidth='';
                self.pxheight='';
                this.label='请选择'
            }
        },
         getPath(file){    
           let url = null;
            if (window.createObjectURL != undefined) {
                // basic
                url = window.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                // webkit or chrome
                url = window.webkitURL.createObjectURL(file);
            } else if (window.URL != undefined) {
                // mozilla(firefox)
                url = window.URL.createObjectURL(file);
            }
            console.log(url)
            return url;
        },
        submit(){//图片裁剪提交
            if(this.filetext==''){
                this.$message.error("请先选择裁剪图片");
                return false
            }else{
                if(this.pxwidth>this.width){
                     this.$message.error(`裁剪长度不能超过: ${this.width} 像素`)
                     return false
                }
                if(this.pxheight>this.height){
                     this.$message.error(`裁剪宽度不能超过: ${this.height} 像素`)
                     return false
                }
                if(this.pxwidth==0||this.pxheight==0||this.pxwidth==''||this.pxheight==''){
                    this.$message.error(`裁剪值不能为空或者为0,请填写数值!`)
                     return false
                }
                let serviceUrl = process.env.VUE_APP_Domain+'/ISaveUserInfo';
				let params={
						filepath:this.filepath,
						width:this.pxwidth,
						height:this.pxheight
				}
				axios.get(serviceUrl, {  //params参数必写 , 如果没有参数传{}也可以
					params: params
				}).then(res=>{
					
				})
            }
        },
        Adressumbit(){//图片下载地址提交
            if(this.inputpath==''){
                this.$message.error("请输入图片下载地址");
                return false
            }else{
                return false
                let serviceUrl = process.env.VUE_APP_Domain+'/ISaveUserInfo';
				let params={
                        inputpath:this.inputpath,
				}
				axios.get(serviceUrl, {  //params参数必写 , 如果没有参数传{}也可以
					params: params
				}).then(res=>{
					
				})
            }
        },
        download(href, name) {
            let eleLink = document.createElement('a')
            eleLink.download = name
            eleLink.href = href
            eleLink.click()
            eleLink.remove()
        },
        upload() {
            let folder = 'test-upload';
            let file = $('#upload')[0].files[0];
            console.log(file);
            fsvc.Upload(file, file.name, folder)(null, function (res) {
                console.log(res)
            });
        }  
    }
}
</script>

<style>

</style>